import { Redirect } from 'react-router-dom';

import roles from '../config/roles';

// Authentication related pages
import Login from '../pages/Authentication/Login';
import Register from '../pages/Authentication/Register';
import Logout from '../pages/Authentication/Logout';
import ForgetPassword from '../pages/Authentication/ForgetPassword';

// All protected pages
import Dashboard from '../pages/Dashboard';
import SubscriptionsList from '../pages/Subscriptions/List';
import UsersList from '../pages/Users/List';
import Settings from '../pages/Settings';
import Home from '../pages/Home';

// Affiliate pages
import AffiliatesList from '../pages/Affiliates/List';
import Commissions from '../pages/Affiliates/Commissions';

// Discount codes pages
import DiscountCodesList from '../pages/DiscountCodes/List';

const userRoutes = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: 'bx bx-home-alt',
    component: Dashboard,
  },
  {
    title: 'Subscriptions',
    path: '/subscriptions/list',
    component: SubscriptionsList,
    icon: 'bx bx-credit-card',
    permission: [roles.SUPER_ADMIN, roles.ADMIN],
  },
  {
    title: 'Users',
    path: '/users/list',
    component: UsersList,
    icon: 'bx bx bx-user-circle',
    permission: [roles.SUPER_ADMIN, roles.ADMIN],
  },
  {
    title: 'Codici Sconto',
    path: '/discount-codes/list',
    component: DiscountCodesList,
    icon: 'bx bxs-coupon',
    permission: [roles.SUPER_ADMIN, roles.ADMIN],
  },
  {
    group: 'Affiliates',
    icon: 'bx bx-share-alt',
    children: [
      {
        title: 'Affiliates',
        path: '/affiliates/list',
        component: AffiliatesList,
        permission: [roles.SUPER_ADMIN, roles.ADMIN],
      },
      {
        title: 'Commissions',
        path: '/affiliates/commissions',
        component: Commissions,
        permission: [roles.SUPER_ADMIN, roles.ADMIN, roles.AFFILIATE],
      },
    ],
  },
  {
    path: '/settings',
    component: Settings,
  },

  { path: '/', exact: true, component: () => <Redirect to="/dashboard" /> },
];

const authRoutes = [
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/forgot-password', component: ForgetPassword },
  { path: '/index', exact: true, component: Home },
];

export { userRoutes, authRoutes };
